import { RecurrenceSettingsState } from '../../types'

type InitializerArg = {
  value: uui.domain.ui.forms.RecurrenceSettings
  todayDate: Date
}

export function createInitialState({ value, todayDate }: InitializerArg): RecurrenceSettingsState {
  return {
    referenceDate: todayDate,
    value,
    isUpdatingFromProps: false,
  }
}
